<app-nav [title]="title"></app-nav>
<div class="content-wrapper pt-1">
  <div class=”container”>
    <router-outlet></router-outlet>
  </div>
</div>
<app-footer></app-footer>